<div mat-dialog-title>
  <mode-dialog-header [hideClose]="hideClose">
    <h1 heading>Your trial has ended</h1>
  </mode-dialog-header>
</div>
<div mat-dialog-content>
  <p>But there are options! Talk to a Mode representative to see what you can do next.</p>
</div>
<div mat-dialog-actions>
  <mode-calendly-popup-button [userDisplayName]="data.userDisplayName" [userEmail]="data.userEmail" capraTooltip
    tooltipPlacement="top"
    tooltipContent="<p>Schedule a product demo</p><p>Flexible seat count<br/>100 GB/month<br/>Up to 10 GB/query</p>"
    tooltipContentIsHtml="true">
    <capra-button (clicked)="trackClick('Trial expired dialog', 'Book a call')" text="Book a call" color="neutral-dark"></capra-button>
  </mode-calendly-popup-button>
  <mode-calendly-popup-button [userDisplayName]="data.userDisplayName" [userEmail]="data.userEmail"
    [schedulerUrl]="'https://calendly.com/mode/buy-mode-now?primary_color=37b067%27'" capraTooltip
    tooltipPlacement="top"
    tooltipContent="<p>Special Offer for Startups</p><p>10 GB/month<br/>1 GB/query</p><p>*For workspaces with 1-20 employees*</p>"
    tooltipContentIsHtml="true">
    <capra-button (clicked)="trackClick('Trial expired dialog', 'Buy Mode now')" text="Buy Mode now"></capra-button>
  </mode-calendly-popup-button>
</div>
